import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ItemsLevelInterfaces } from '../../interfaces/password-level.interfaces';

@Component({
  selector: 'app-password-level',
  templateUrl: './password-level.component.html',
  styleUrls: ['./password-level.component.scss'],
})
export class PasswordLevelComponent implements OnInit, OnChanges {
  @Input() itemsLevel!: Array<ItemsLevelInterfaces>;
  @Input() validSecurity: number = 0;
  public optionsList: any;
  public active: string = 'Baja';

  ngOnInit(): void {
    !this.itemsLevel && this.setItemsLevel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['validSecurity']) {
      this.setItemsLevel();
    }
  }

  setItemsLevel() {
    this.itemsLevel = [
      { label: 'Baja', status: this.validSecurity > 0 ? 'valid' : 'invalid' },
      { label: 'Media', status: this.validSecurity > 2 ? 'valid' : 'invalid' },
      { label: 'Alta', status: this.validSecurity > 4 ? 'valid' : 'invalid' },
    ];

    this.itemsLevel.forEach((item) => {
      this.active = item.status === 'valid' ? item.label : this.active;
    });
  }
}
